import { IPermissionsInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const permissionsSelector = (state: RootState) => state.permissions;

const permissionsListSelector = createSelector([permissionsSelector], (permissions: IPermissionsInitialState) => permissions.permissionsList);

export const permissionsSel = {
    permissionsSelector,
    permissionsListSelector,
};
